import React, { memo } from 'react';
import {
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Pagination,
} from '@mui/material';

const PaginationControls = ({
    rowsPerPage,
    onRowsPerPageChange,
    currentPage,
    totalPages,
    onPageChange,
}) => {
    return (
        <Box
            sx={{
                mt: 2,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
        >
            <FormControl variant="standard" sx={{ minWidth: 120 }}>
                <InputLabel id="rows-per-page-label">Rows per page</InputLabel>
                <Select
                    labelId="rows-per-page-label"
                    id="rows-per-page"
                    value={rowsPerPage}
                    onChange={onRowsPerPageChange}
                    label="Rows per page"
                >
                    <MenuItem value={5}>5</MenuItem>
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={25}>25</MenuItem>
                    <MenuItem value={50}>50</MenuItem>
                </Select>
            </FormControl>
            <Pagination
                count={totalPages}
                page={currentPage}
                onChange={onPageChange}
                color="primary"
                size="small"
            />
        </Box>
    );
};

export default memo(PaginationControls);
